// extracted by mini-css-extract-plugin
export default {"title":"AdvancePaymentDetails_title__5zN6U","total":"AdvancePaymentDetails_total__VSRSA","edit":"AdvancePaymentDetails_edit__JZVtf"};